<template>
  <div class="creditExtension">
    <div class="title">企业确认授信</div>
    <div class="orderdetails">
      <div class="orderTitle">订单信息</div>
      <div class="orderContent">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-row>
            <el-col :span="8"
              ><el-form-item label="订单编号">
                <el-input
                  v-model="search.orderNo"
                  style="width: 160px"
                  placeholder="请输入内容"
                  readonly
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="8"
              ><el-form-item label="订单状态">
                <el-select
                  ref="select"
                  v-model="search.status"
                  placeholder="状态"
                  size="small"
                  style="width: 160px; margin-right: 20px"
                  filterable
                  clearable
                  readonly
                  disabled
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.status"
                    :label="item.labal"
                    :value="item.status"
                  />
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="下单时间">
                <el-input
                  v-model="search.time"
                  style="width: 160px"
                  placeholder="请输入内容"
                  readonly
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="product">
      <div class="orderTitle">产品信息</div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :highlight-current-row="true"
        stripe
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="cpmc" label="产品名称" width="220" />
        <el-table-column prop="zdnhlv" label="利率范围">
          <template slot-scope="scope">
            {{ scope.row.zdnhlv }}% - {{ scope.row.zgnhlv }}%
          </template>
        </el-table-column>
        <el-table-column prop="dkqx" label="贷款期限（月）" width="120">
          <template slot-scope="scope">
            {{ scope.row.dkqxxx }} - {{ scope.row.dkqxsx }}
          </template>
        </el-table-column>
        <el-table-column prop="dked" label="贷款额度（万元）" width="150">
          <template slot-scope="scope">
            {{ scope.row.dkedxx }} - {{ scope.row.dkedsx }}
          </template>
        </el-table-column>
        <el-table-column prop="dbfsm" label="担保方式"> </el-table-column>
        <el-table-column prop="dklxm" label="贷款类型"> </el-table-column>
        <el-table-column prop="khjl" label="客户经理" width="150">
          <template slot-scope="scope">
            {{ scope.row.khjl }}
          </template>
        </el-table-column>
        <el-table-column prop="lxrdh" label="客户经理联系电话" width="150" />
        <el-table-column prop="jrjgmg" label="所属机构" width="200">
        </el-table-column>
      </el-table>
    </div>
    <div class="requirement">
      <div class="orderTitle">企业融资需求</div>
      <div class="formBox">
        <el-form :model="form" class="demo-form-inline" label-width="200px">
          <el-form-item label="申请企业">
            <el-input
              v-model="form.qymc"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input> </el-form-item
          ><el-form-item label="贷款额度（万元）">
            <el-input
              v-model="form.dked"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="贷款期限（月）">
            <el-input
              v-model="form.dkqx"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="年利率（%）">
            <el-input
              v-model="form.nhlv"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="担保方式">
            <el-input
              v-model="form.dbfsm"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="信贷类型">
            <el-input
              v-model="form.dklxm"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input
              v-model="form.khjl"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="form.lxrdh"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="审核意见">
            <el-input
              v-model="form.suggest"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="授信意见">
            <el-input
              v-model="form.creditSuggest"
              style="width: 260px"
              placeholder="请输入内容"
              type="textarea"
              :rows="4"
              readonly
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="确认授信">
            <el-input
              v-model="form.qyCreditSuggest"
              style="width: 260px"
              placeholder="请输入内容"
              type="textarea"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="buttonList">
          <span class="button" @click="product(true)">同意授权</span>
          <span class="button" @click="product(false)">不同意授权</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetailPortals, productOrder } from "./viewApi";
import { FormatDatec } from "@/filters/index.js";
export default {
  data() {
    return {
      page: {
        size: 10,
        total: 0,
        current: 1,
      },
      orderNo: this.$route.query.orderNo,
      statusList: [
        {
          status: 1,
          labal: "待审核",
        },
        {
          status: 2,
          labal: "审核不通过",
        },
        {
          status: 3,
          labal: "授信中",
        },
        {
          status: 4,
          labal: "授信待确认",
        },
        {
          status: 5,
          labal: "金融机构授信不通过",
        },
        {
          status: 6,
          labal: "撮合成功",
        },
        {
          status: 7,
          labal: "企业不同意授信",
        },
        {
          status: 8,
          labal: "已完成",
        },
      ],
      tableData: [],
      search: {
        time: "",
        status: 1,
        orderNo: this.$route.query.orderNo,
      },
      companyName: "",
      form: {
        qymc: "",
        creditSuggest: null,
        lxrdh: null,
        khjl: null,
        dklxm: null,
        dbfsm: null,
        zgnhlv: null,
        dkqx: null,
        dked: null,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    product(isTrue) {
      let params = {
        id: this.$route.query.id,
        status: isTrue ? 6 : 7,
        qyCreditSuggest: this.form.qyCreditSuggest,
      };
      productOrder(params).then((res) => {
        if (res.code == 1000) {
          this.$baseMessage("操作成功", "success");
          this.$router.push({
            path: "trading",
          });
        }
      });
    },
    async getData() {
      let res = await getDetailPortals({ id: this.$route.query.id });
      if (res.data) {
        this.tableData.push(res.data);
        this.form = res.data;
        this.search.time = FormatDatec(res.data.createTime);
        this.search.status = Number(this.$route.query.status);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.creditExtension {
  .title {
    border-bottom: 1px solid #ccc;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
  }
  .orderdetails,
  .product,
  .requirement {
    margin-top: 20px;
    text-align: center;
    .orderTitle {
      border-bottom: 1px solid #ccc;
      line-height: 40px;
      padding: 0 10px;
      text-align: left;
    }
    .orderContent {
      margin-top: 20px;
    }
    .formBox {
      display: inline-block;
      width: 50%;
      margin-top: 20px;
      .buttonList {
        display: inline-block;
        padding: 20px;
        .button {
          display: inline-block;
          margin-bottom: 10px;
          border: 1px solid #1366ec;
          padding: 5px 15px;
          border-radius: 5px;
          background: #1366ec;
          color: #fff;
          cursor: pointer;
          &:nth-child(1) {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>